import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import moment from 'moment';
import { ROOM_CATEGORY } from "constant/constants";
import axios from 'axios';
import { mainUrl } from 'API/client/api';
import { createPropertyLogs } from 'store/slices/PropertyData';
import { useDispatch } from 'react-redux';

const ModalQuickSoldOut = ({ show, hide, selectedDates, setSelectedDates, setIsDirty, rooms, handleQuickSoldOut, handleStatusChange, hotelInfo, userDetail }) => {

  const dispatch = useDispatch();

  const [selectedDatesCheck, setSelectedDatesCheck] = useState([]);
  const [roomInfo, setRoomInfo] = useState([]);
  const [datesArr, setDatesArr] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [error, setError] = useState('')

  useEffect(() => { setSelectedDatesCheck(selectedDates) }, [show]);

  useEffect(() => { setSelectedDates(selectedDatesCheck) }, [selectedDatesCheck])

  const handleClose = () => {
    hide(false);
    setSelectedDatesCheck([])
  };

  const [logData, setLogData] = useState([])

  const handleDateClick = (date) => {
    if (!date) return;
    const clickedDate = moment(date).format("YYYY-MM-DD");
    setSelectedDatesCheck((prevDates) => {
      const safePrev = Array.isArray(prevDates) ? prevDates : [];
      const exists = safePrev.find((d) => d.date === clickedDate);
      if (exists) {
        // Toggle soldOut for existing date
        return safePrev.map((d) =>
          d.date == clickedDate ? { ...d, soldOut: !d.soldOut } : d
        );
      } else {
        // Add new date with default soldOut = true (or false, depending on your logic)
        return [...safePrev, { date: clickedDate, soldOut: true }];
      }
    });

    setLogData(prev => {
      const safePrev = Array.isArray(prev) ? prev : [];
      const exists = safePrev.find(d => d.date === clickedDate);
      // const existsFromSelected = selectedDatesCheck.find((item) => item.date == clickedDate && item.soldOut == true)
      const existsFromSelected = Array.isArray(selectedDatesCheck)
        ? selectedDatesCheck.filter(
          (item) => item.date == clickedDate && item.soldOut == true
        )
        : Object.values(selectedDatesCheck || {}).find(
          (item) => item?.date == clickedDate && item?.soldOut == true
        );

      if (exists) {
        return safePrev.filter(d => d.date !== clickedDate);
      }
      else if (existsFromSelected) {
        return [...safePrev, { date: clickedDate, soldOut: false }];
      }
      else {
        return [...safePrev, { date: clickedDate, soldOut: true }];
      }
    });
  };

  const handleSubmit = async () => {
    if (selectedCategories.length == 0) {
      setError('Please select a category');
      return
    }
    await handleQuickSoldOut(selectedCategories);
    const params = {
      action: `Stop Sell`,
      actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
      operation: JSON.stringify({ date: logData, categoryIds: selectedCategories }),
      propertyId: userDetail?.propertyId
    }
    dispatch(createPropertyLogs(params))

    cateForThird?.forEach((cateId) => {
      const RoomsCategoryId = cateId == 1 ? "STANDARD DOUBLE BED"
        : cateId == 2 ? "DELUXE ROOM"
          : cateId == 3 ? "SUITE ROOM"
            : cateId == 5 ? "STANDARD SINGLE BED"
              : cateId == 6 ? "STANDARD TWIN BED"
                : cateId == 7 ? "DELUXE TWIN BED"
                  : cateId == 9 ? "FAMILY ROOM"
                    : cateId == 10 ? "PREMIUM ROOM"
                      : "STANDARD DOUBLE BED";
      const RoomTypeID = roomInfo?.find(
        (item) => item?.RoomType?.toUpperCase() == RoomsCategoryId?.toUpperCase()
      )?.RatePlanID;
      if (RoomTypeID) { updateStopSell(RoomTypeID) }
    })

    hide(false);
    setError('')
    setSelectedDatesCheck([])
    setSelectedCategories([])
  };

  useEffect(() => { if (selectedCategories.length > 0) { setError('') } }, [selectedCategories])

  const handleCheck = (value) => {
    setSelectedCategories((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const handleAll = (checked) => { setSelectedCategories(checked ? rooms.map((r) => r.id) : []); };

  useEffect(() => { if (selectedDatesCheck.length > 0) { setDatesArr(selectedDatesCheck?.map((data) => data?.date)) } }, [selectedDatesCheck])

  const categories = rooms?.map((item) => {
    return {
      label: ROOM_CATEGORY?.[item?.categoryId].toLowerCase().replace(/\b\w/g, c => c.toUpperCase()),
      value: item?.id,
      categoryId: item?.categoryId
    }
  })

  const [cateForThird, setCateForThird] = useState([])

  useEffect(() => {
    const result = categories?.filter(item => selectedCategories.includes(item.value))
      .map(item => item.categoryId);
    setCateForThird(result)
  }, [selectedCategories])

  const fetchRoomInformation = async () => {
    const payload = {
      RES_Request: {
        Request_Type: "RoomInfo",
        NeedPhysicalRooms: 1,
        Authentication: {
          HotelCode: hotelInfo?.locationId,
          AuthCode: hotelInfo?.authCode
        }
      }
    }
    try {
      const res = await axios.post(`${mainUrl}api/proxy`, payload);
      if (res) {
        setRoomInfo(res.data.data.RoomInfo.RatePlans.RatePlan)
      }
    } catch (err) {
      console.log('Error:', err.response ? err.response.data : err.message)
    }
  }

  useEffect(() => {if (hotelInfo) {fetchRoomInformation()}}, [hotelInfo])

  const updateStopSell = async (RoomTypeID) => {
    const today = moment().startOf('day');
    let payload = {
      RES_Request: {
        Request_Type: "UpdateStopSell",
        Authentication: {
          HotelCode: hotelInfo?.locationId,
          AuthCode: hotelInfo?.authCode
        },
        RatePlan: selectedDates
          .filter(d => moment(d.date).isSameOrAfter(today))
          .map(date => ({
            RatePlanID: RoomTypeID,
            FromDate: moment(date.date).format('YYYY-MM-DD'),
            ToDate: moment(date.date).format('YYYY-MM-DD'),
            StopSell: date.soldOut ? "1" : "0"
          }))
      }
    }
    try {
      const res = await axios.post(`${mainUrl}api/stop-sell`, payload);
    } catch (err) { console.error('Stop Sell Update Failed:', err) }
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Select Sold-Out Dates</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='p-2 quick-sold-out'>
          <div className='custom-datePicker'>
            <DatePicker
              inline
              selected={null}
              onChange={handleDateClick}
              minDate={new Date()}
              maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
              // dayClassName={(date) =>
              //   (Array.isArray(selectedDatesCheck) ? selectedDatesCheck : []).some((d) => d.date == moment(date).format("YYYY-MM-DD"))
              //     ? "selected-day"
              //     : "unselected-day"
              // }
              dayClassName={(date) => {
                const safeDates = Array.isArray(selectedDatesCheck) ? selectedDatesCheck : [];
                const clickedDate = moment(date).format("YYYY-MM-DD");
                const match = safeDates.find((d) => d.date === clickedDate);
                return match?.soldOut ? "selected-day" : "unselected-day";
              }}
            />
          </div>
          <div className='text-center border-top pt-4 mt-2'>
            <h5 className='text-left text-dark fs-7'>Select Room Category <span className='text-danger'>*</span></h5>
            <ul>
              <li
                className={
                  selectedCategories.length === rooms.length ? "active" : ""
                }
              >
                <label>
                  <input
                    type="checkbox"
                    checked={selectedCategories.length === rooms.length}
                    onChange={(e) => handleAll(e.target.checked)}
                  />
                  All
                </label>
              </li>

              {rooms?.map((item) => (
                <li
                  key={item.categoryId}
                  className={
                    selectedCategories.includes(item.id) ? "active" : ""
                  }
                >
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(item.id)}
                    onChange={() => handleCheck(item.id)}
                  />
                  <label>
                    {ROOM_CATEGORY?.[item.categoryId]
                      ?.toLowerCase()
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </label>
                </li>
              ))}


            </ul>
            {error && <p className='text-danger fs-8 text-left pt-2'>{error}</p>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-dark btn-md" variant="black" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Sold-Out
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalQuickSoldOut